export default Object.freeze({
	FLEXPOS: 'flexpos',
	ELASTIC_SEARCH: 'elasticSearch',
});
